<div class="main">
    <div class="sim-consent-table">
        <div class="left">
            <ng-container>
                <div style="padding-top: 13px; position: sticky; top: 0px;z-index: 1300;">
                    <mat-radio-group  (change)="toggleConsentAndLocation($event.value)">
                        <mat-radio-button style="font-size:12px; padding:8px 12px 12px 0px;" value="1" checked>{{'SIMCONSENT.consent_radio' | translate}}</mat-radio-button>
                        <mat-radio-button style="font-size: 12px; padding: 8px 0px 12px 12px;" value="2">{{'SIMCONSENT.location_radio' | translate}}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </ng-container>
            <div class="table" >
                <table style="background: none; margin-bottom: 60px;" mat-table [dataSource]="simConsentData" class="loadTable">
                    <ng-container matColumnDef="Ind">
                        <th mat-header-cell *matHeaderCellDef class="customHeader" style="font-size: 12px;font-weight: medium;color: #131722;">
                            {{ '#' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;">
                            <div style="display: flex; flex-direction: row;">
                                <div style="margin:21px auto 21px 24px">
                                    {{ i+1 }}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="SIN">
                        <th mat-header-cell *matHeaderCellDef class="customHeader" style="font-size: 12px;font-weight: medium;color: #131722; max-width: 120px;">
                            <input class="filter-input" placeholder="SIN" value="searchSIN" [(ngModel)]="searchSIN" (input)="filterSIN(); $event.preventDefault()" />
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; flex-direction: row;">
                                <div style="margin:21px auto 21px 5px">
                                    {{ element.SIN }}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Driver Name">
                        <th mat-header-cell *matHeaderCellDef class="customHeader" style="font-size: 12px;font-weight: medium;color: #131722; min-width: 120px;">
                            {{ 'SIMCONSENT.driver_name' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; flex-direction: row;">
                                <div style="margin:21px auto 21px 5px">
                                    {{ element.name}}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Driver Mobile">
                        <th mat-header-cell *matHeaderCellDef class="customHeader" style="font-size: 12px;font-weight: medium;color: #131722;">
                            <input class="filter-input" placeholder="Driver Mobile" value="searchMobile" [(ngModel)]="searchMobile" (input)="filterMobile(); $event.preventDefault()" />
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; flex-direction: row;">
                                <div style="margin:21px auto 21px 5px">
                                    {{ element.mobile}}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Carrier Name">
                        <th mat-header-cell *matHeaderCellDef class="customHeader" style="font-size: 12px;font-weight: medium;color: #131722;">
                            {{ 'SIMCONSENT.carrier_name' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; flex-direction: row;">
                                <div style="margin:21px auto 21px 5px">
                                    {{ element.carrier }}
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Service Provider">
                        <th mat-header-cell *matHeaderCellDef class="customHeader" style="font-size: 12px;font-weight: medium;color: #131722;">
                            {{ 'SIMCONSENT.service_provider' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; flex-direction: row;">
                                <div style="margin:auto auto 0px 5px">
                                    <mat-form-field floatLabel='never'  class="service_provider-dropdown" >
                                        <mat-label> {{element.service_provider | translate}}</mat-label>
                                        <mat-select (selectionChange)="makeChange(element, $event.value)"
                                          style="color: #fff;width: 96%;padding-top: 4px;padding-left: 5px;padding-bottom: 4px;">
                                          <mat-option  *ngFor="let provider of serviceProviders" [value]="provider">{{provider}}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Subscription Time">
                        <th mat-header-cell *matHeaderCellDef class="customHeader" style="font-size: 12px;font-weight: medium;color: #131722;">
                            
                            {{((consentRadioButton)? 'SIMCONSENT.subscription_time' : 'SIMCONSENT.consent_time')| translate }}
                            <div class="help" (click)="openPopup()">
                                <span><img alt="" src="assets/helpicon.svg" style="width: 17px;margin-top: 3px;"></span>
                            </div>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <!-- <div > -->
                                    <div style="margin:10px auto 10px 5px">
                                        {{ (consentRadioButton)? element.subscription_time : element.consent_time || 'N/A' }}
                                        <p *ngIf="element.isConsentExpired" style="color: red;font-size: 10px;">Consent is expired, please resubscribe</p>
                                    </div>
                                    
                                <!-- </div> -->
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Resubscribe">
                        <th mat-header-cell *matHeaderCellDef class="customHeader" style="font-size: 12px;font-weight: medium;color: #131722;">
                            {{ 'SIMCONSENT.action' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div style="display: flex; flex-direction: row;">
                                <div style="margin:13px auto 13px 5px">
                                    <div class="button" style="padding: 8px 16px 8px 16px;" (click)="resubscribe(element)">
                                        {{'SIMCONSENT.resubscribe' | translate}}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </ng-container>
                    <tr style="top: 48px; position: sticky; z-index: 1200" mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                    <tr mat-row *matRowDef="let row; let i = index; columns: displayedColumns"
                        [ngClass]="{ highlightTableColor: selectedRowIndex == i }" ></tr>
                </table>
            </div>
        </div>
    </div>
    <div *ngIf="isPopupOpen" class="popup-container">
        <!-- Popup content -->
        <div (click)="closePopup()">
            <button  mat-icon-button class="close-button" [mat-dialog-close]="true">
                <mat-icon class="close-icon" >close</mat-icon>
              </button>
        </div>
        <div class="popup-content">

          <h2 class="title">Tracking Consent Information</h2>
            <ol style="margin-bottom: 15px;">
                <li >Subscribers of <b>Airtel</b>, <b>BSNL</b>, <b>Vodafone</b>, and <b>Idea</b> are required to provide consent for tracking within <b>8 hours</b> of subscription.</li>
                <li> While <b>Jio</b> subscribers need to give their consent within <b>4 hours</b>.</li>
                <li> However, should the <b>mobile number have been ported</b> to a different service provider, tracking will not begin even with consent. To resolve this, update the service provider details for the mobile number and resubscribe to activate tracking.</li>
            </ol>
        
            <div style="display:flex; justify-content: center;">
                <table style="border-collapse: collapse; width: 60%; margin-bottom: 20px;">
                    <thead>
                    <tr>
                        <th style="padding: 8px;">Operator</th>
                        <th style="padding: 8px;">Consent Requirement for Tracking</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td style="padding: 8px;">Airtel, BSNL, Vodafone, Idea</td>
                        <td style="padding: 8px;">Within 8 hours of subscription</td>
                    </tr>
                    <tr>
                        <td style="padding: 8px;">Jio</td>
                        <td style="padding: 8px;">Within 4 hours of subscription</td>
                    </tr>
                    </tbody>
                </table>
            </div>
    </div>
</div>
